// Map Vite env variables (VITE_*) to CRA-style process.env.REACT_APP_*
// This lets existing code keep using process.env.REACT_APP_* during the Vite transition.

const e = import.meta.env || {};

if (typeof globalThis.global === 'undefined') {
  globalThis.global = globalThis;
}

if (!globalThis.process) {
  // minimal polyfill
  // eslint-disable-next-line no-undef
  globalThis.process = { env: {} };
} else if (!globalThis.process.env) {
  globalThis.process.env = {};
}

globalThis.process.env = {
  ...globalThis.process.env,
  REACT_APP_STRIPE_KEY: e.VITE_STRIPE_KEY,
  REACT_APP_GOOGLE_API_KEY: e.VITE_GOOGLE_API_KEY,
  REACT_APP_API_URL: e.VITE_API_URL,
  REACT_APP_API_BASE: e.VITE_API_BASE,
  REACT_APP_MEDIA_BASE: e.VITE_MEDIA_BASE,
  REACT_APP_ENV: e.VITE_ENV,
  REACT_APP_ADMIN_BASE_URL: e.VITE_ADMIN_BASE_URL,
};
